import { useMutation, useQueryClient } from "@tanstack/react-query";
import { apiRequest } from "../hooks/apiRequest";
import { TaskProps, TaskStatus } from "../types/interfaces";
import { taskKeys } from "../utils/queryKeys";

export function useAddSubtask(taskId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (data: { title: string; assigneeId?: string; storyPoints?: number }) =>
      (await apiRequest<TaskProps>(`tasks/${taskId}/subtasks`, {
        method: "POST",
        body: JSON.stringify(data),
      })).data,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: taskKeys.detail(taskId) }),
  });
}

export function useUpdateSubtask(taskId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async ({ subtaskId, status }: { subtaskId: string; status: TaskStatus }) =>
      (await apiRequest<TaskProps>(`tasks/${taskId}/subtasks/${subtaskId}`, {
        method: "PUT",
        body: JSON.stringify({ status }),
      })).data,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: taskKeys.detail(taskId) }),
  });
}

export function useDeleteSubtask(taskId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (subtaskId: string) =>
      (await apiRequest<TaskProps>(`tasks/${taskId}/subtasks/${subtaskId}`, { method: "DELETE" })).data,
    onSuccess: () => queryClient.invalidateQueries({ queryKey: taskKeys.detail(taskId) }),
  });
}
